import { AvailableLanguages } from "../types";
function loadLocalesData(locale, locales) {
    const loadRequestedLocale = locales[locale];
    if (loadRequestedLocale) {
        return [
            loadRequestedLocale()
        ];
    }
    const loadDefaultLocale = locales[AvailableLanguages.English];
    if (loadDefaultLocale) {
        return [
            loadDefaultLocale()
        ];
    }
    throw new Error("No locale loaders are configured.");
}
export default loadLocalesData;
